module.exports = __webpack_public_path__ + "static/media/pencil.782207b6.svg";